import { CommonActionTypes } from '../constants'
import { minimizeInteractiveElementsList } from './interactiveElementsListActions'
import { Map } from 'immutable'
import { currentStop, delay } from '../../utils/functions'

/**
 * @function setVisited - Mark an interactive element as visited
 */
export const setVisited = data => {
    return (dispatch, getState) => {
        const state = getState()
        const stopId = state.getIn(['interactiveElements', 'currentScene', 'stopId'])
        const visitedByStop = state.getIn(['interactiveElements', 'meta', 'visited', 'byStop', String(stopId)])
        const elements = state.getIn(['interactiveElements', 'meta', 'totalElements', 'byStop', String(stopId)]) || []

        // If stop changes before we dispatch the action, don't count it
        // Sometimes this happens when an autoplayed video is paused on scene change
        if (elements.find(item => item.get('type') === data.type && item.get('id') === data.id)) {
            const actions = [
                {
                    type: CommonActionTypes.SET_VISITED,
                    data,
                    visitedByStop,
                    stopid: stopId,
                },
            ]

            // if visitedElement list not set for specified stop, then this is the first
            // interactive element visited and we need to show InteractiveElementList in
            // the minimimzed state
            if (typeof visitedByStop === 'undefined') {
                actions.push(minimizeInteractiveElementsList())
            }
            dispatch(actions)
        }
    }
}

export const hydrateInteractive = data => ({
    type: CommonActionTypes.HYDRATE_INTERACTIVE,
    data,
})

export const openPreview = el => async (dispatch, getState) => {
    const state = getState()
    const openEl = state.getIn(['interactiveElements', 'preview'])

    if (openEl.get('id')) {
        dispatch(closePreview())
        await delay(325) // wait for animation and unmount
        dispatch({
            type: CommonActionTypes.OPEN_PREVIEW,
            el: Map(el),
        })
    } else {
        dispatch({
            type: CommonActionTypes.OPEN_PREVIEW,
            el: Map(el),
        })
    }
}
export const closePreview = id => ({
    type: CommonActionTypes.CLOSE_PREVIEW,
})

export const openModal = el => ({
    type: CommonActionTypes.OPEN_MODAL,
    el,
})

export const closeModal = el => ({
    type: CommonActionTypes.CLOSE_MODAL,
    el,
})

export const setScene = scene => ({
    type: CommonActionTypes.SET_SCENE,
    scene,
})

export const forceMediaPause = forceBoolean => ({
    type: CommonActionTypes.FORCE_MEDIA_PAUSE,
    forceBoolean,
})

export const setDragHintDetails = draggingHint => ({
    type: CommonActionTypes.SET_DRAG_HINT_DETAILS,
    draggingHint: Map(draggingHint),
})
